import React from 'react';
import ArrowUpRight from '../../../Assets/Modals/ArrowUpRight.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { closeModal } from '../../../Features/searchSlice';
import { useDispatch } from 'react-redux';

function SearchItem({ searchItem, category, text, bg, title }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const handleSearchResultClick = () => {
        if(searchItem.source === 'Product') {
            const route = `/inventory-management/product/${searchItem.id}`;
            navigate(route);
            dispatch(closeModal());
        }
        else if(searchItem.source === 'Order Id') {
            const route = `/order-management/${searchItem.orderId}`
            navigate(route);
            dispatch(closeModal());
            if(!location.pathname.includes(route)) {
                window.location.reload();
            }
        }
        else if(searchItem.source === 'Category Collection') {
            const route = `/collections/categories/${searchItem.CategoryId}/collection/${searchItem.id}`;
            navigate(route);
            dispatch(closeModal());
        }
        else if(searchItem.source === 'Custom Collection') {
            const route = `/collections/custom-collections/${searchItem.id}`;
            navigate(route);
            dispatch(closeModal());
        }
        else if(searchItem.source === 'Coupon') {
            const route = `/coupon-management/coupon/${searchItem.id}`;
            navigate(route);
            dispatch(closeModal());
        }
        else {
            console.log(searchItem);
        }
    }

    return (
        <div onClick={handleSearchResultClick} className='cursor-pointer flex items-center gap-2 border-b border-[#EAEAEA] py-4'>
            <h1 className='font-medium text-[14px] leading-6 text-[#121212]'>{title}</h1>

            <div className="flex items-center gap-1 ml-auto">
                <span 
                    className={`${text} ${bg} px-3 py-1 rounded-lg font-medium text-[12px] leading-5`}
                >
                    {category}
                </span>

                <div className="size-6 flex items-center justify-center">
                    <img src={ArrowUpRight} alt="" />
                </div>
            </div>
        </div>
    );
}

export default SearchItem;
